import { TrackingPlaceInApp } from '@ardoq/data-model';
import { trackEvent } from 'tracking/tracking';

const { RIGHT_PANE } = TrackingPlaceInApp;

const trackButtonClicked = (action: string, isViewpointMode: boolean) => {
  trackEvent(`${RIGHT_PANE} clicked ${action}`, {
    isViewpointMode,
  });
};

export const trackRightPaneClosed = (isViewpointMode: boolean) => {
  trackButtonClicked('close', isViewpointMode);
};

export const trackSaveComponentButtonClicked = (isViewpointMode: boolean) => {
  trackButtonClicked('save component', isViewpointMode);
};

export const trackCreateComponentButtonClicked = (isViewpointMode: boolean) => {
  trackButtonClicked('create component', isViewpointMode);
};

export const trackDeleteComponentButtonClicked = (isViewpointMode: boolean) => {
  trackButtonClicked('delete component', isViewpointMode);
};
